export const LIST_COURSES_REQ = "listCoursesReq";
export const LIST_COURSES_SUCCESS = "listCoursesSuccess";
export const LIST_COURSES_FAILED = "listCoursesFailed";
